var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31433 13.7694L15.576 5.50772L14.2762 4.16381L7.31433 11.1477L4.05371 7.86506L2.75386 9.16491L7.31433 13.7694ZM9.165 0C10.8394 0 12.3889 0.41859 13.8136 1.25578C15.1942 2.04891 16.2811 3.13577 17.0742 4.51641C17.9114 5.9411 18.33 7.49062 18.33 9.165C18.33 10.8394 17.9114 12.3889 17.0742 13.8136C16.2811 15.1942 15.1942 16.2811 13.8136 17.0742C12.3889 17.9114 10.8394 18.33 9.165 18.33C7.49062 18.33 5.9411 17.9114 4.51641 17.0742C3.13577 16.2664 2.04891 15.1722 1.25578 13.7916C0.41859 12.3669 0 10.8247 0 9.165C0 7.5053 0.41859 5.96313 1.25578 4.53844C2.0636 3.15781 3.15781 2.0636 4.53844 1.25578C5.96313 0.41859 7.5053 0 9.165 0Z",
    fill: "#57E188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.217f29dd4d450612dfdabdedb2d8d755.svg";
export { ForwardRef as ReactComponent };